// This import loads the firebase namespace along with all its type information.
import MediaProcessJob from './media-process-job-model'

export async function load_mediaProcessJobs(): Promise<MediaProcessJob[]> {
  throw 'Not implemented'
}

export async function delete_mediaProcessJob(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mediaProcessJob(): Promise<MediaProcessJob> {
  throw 'Not implemented'
}
